"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekView = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var WeekViewKonva_1 = require("./WeekViewKonva");
var WeekViewDnD_1 = require("./WeekViewDnD");
var react_konva_1 = require("react-konva");
var hooks_1 = require("../../hooks");
var clsx_1 = __importDefault(require("clsx"));
var WeekView = function (props) {
    var konvaWrapper = (0, react_1.useRef)(null);
    var size = (0, hooks_1.useResizeObserver)({ element: konvaWrapper }).size;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)("flex flex-1 overflow-hidden", props.className), style: { height: props.height }, ref: konvaWrapper }, { children: [size.height === 0 || size.width === 0 ? null : ((0, jsx_runtime_1.jsx)(react_konva_1.Stage, __assign({ height: size.height, width: size.width }, { children: (0, jsx_runtime_1.jsx)(react_konva_1.Layer, { children: (0, jsx_runtime_1.jsx)(WeekViewKonva_1.WeekViewKonva, __assign({}, props, { x: 0, y: 0, height: props.height, width: size.width }), void 0) }, void 0) }), void 0)), (0, jsx_runtime_1.jsx)(WeekViewDnD_1.WeekViewDnD, __assign({}, props), void 0)] }), void 0));
};
exports.WeekView = WeekView;
